/**
 * Octopus IoT Platform - Routes API Service
 * Fase B da integração LAB → principal: rotas como entidade gerenciável
 * (coleção lab_routes, exposta em /api/lab/routes).
 */
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const routesApi = {
  /**
   * List all routes (polyline + comprimento_km) por porto.
   * Response: { routes: [{ id, destino, origem, origin_index, pontos, comprimento_km }] }
   */
  listRoutes: () => axios.get(`${API}/lab/routes`),

  /**
   * Create a route. `comprimento_km` is computed server-side.
   * @param {object} data - { id, destino?, origem?, origin_index?, pontos: [[lon,lat],...] }
   */
  createRoute: (data) => axios.post(`${API}/lab/routes`, data),

  /**
   * Update a route (destino/origem/origin_index/pontos).
   * @param {string} id - Route id
   * @param {object} data - partial fields
   */
  updateRoute: (id, data) => axios.put(`${API}/lab/routes/${id}`, data),

  /**
   * Delete a route.
   * @param {string} id - Route id
   */
  deleteRoute: (id) => axios.delete(`${API}/lab/routes/${id}`),

  /**
   * Parse a KMZ/KML file and return its LineStrings (pontos) without persisting.
   * Used to replace a route's polyline in-place (keeps the same id → preserves
   * geofence bindings). Response: { lines: [{ name, pontos, point_count, length_km }], total }
   * @param {File} file - The KMZ/KML file
   */
  parseFile: (file) => {
    const fd = new FormData();
    fd.append('file', file);
    return axios.post(`${API}/lab/routes/parse`, fd);
  },

  /**
   * Download a route as a KMZ file (blob).
   * @param {string} id - Route id
   */
  exportRoute: (id) => axios.get(`${API}/lab/routes/${id}/export`, { responseType: 'blob' }),
};

export default routesApi;
